import React, { Component } from "react"
import { Container, Row, Col } from "reactstrap"

//Import Images
import error from "../../assets/images/error-img.png"

class Pages500 extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="account-pages my-5 pt-5">
          <Container>
            <Row style={{marginTop: 100}}>
              <Col lg="12">
                <div className="text-center">
                  <h1 className="display-2 fw-medium">
                    erreur 5
                    <i className="bx bx-buoy bx-spin text-primary display-3"/>
                    <i className="bx bx-buoy bx-spin text-primary display-3"/>
                  </h1>
                  <h4 className="text-uppercase">Oops! Quelque chose s&apos;est mal passé de notre côté !</h4>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md="8" xl="6">
                <div>
                  <img src={error} alt="" className="img-fluid" />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default Pages500
